"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyToClipboard = void 0;
var copyToClipboard = function copyToClipboard(textToCopy) {
  /* istanbul ignore else */
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(textToCopy);
  } else {
    // text area method
    var textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    // make the textarea out of viewport
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise(function (res, rej) {
      // use deprecated API in http environment
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
    });
  }
};
exports.copyToClipboard = copyToClipboard;